import { render, staticRenderFns } from "./ContactUpdate.vue?vue&type=template&id=10d19a8c&scoped=true"
import script from "./ContactUpdate.vue?vue&type=script&lang=js"
export * from "./ContactUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d19a8c",
  null
  
)

export default component.exports